export const ROOT_URI = '/agent/Forms';

export default {
  AGENCY_BULLETIN: `${ROOT_URI}/bulletin`,
  INTERACTIVE_FORMS: `${ROOT_URI}/interactiveForms`,
  MARKETING_FORMS: `${ROOT_URI}/marketingForms`,
  PREVIOUS_ORDERS: `${ROOT_URI}/previousOrders`,
};
